module.exports = __webpack_public_path__ + "static/media/advait_karmalkar.ace957d9.jpg";